import { CMDBlackjackCountDown } from "./CMDBlackjackCountDown"
import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDScBlackjackUpdateSetting implements ICommand
{

	public HostID : number = 0;
	public CountDownSetting : CMDBlackjackCountDown;

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.HostID = ba.readUint16();
		this.CountDownSetting = new CMDBlackjackCountDown();
		this.CountDownSetting.fromBytes(ba);
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint16(this.HostID);
		let tempBuf1 = this.CountDownSetting.toBytes().toBuffer();
		ba.appendBuf(tempBuf1)

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDScBlackjackUpdateSetting();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'HostID(W)='+this.HostID+' ';
		str += 'CountDownSetting(CMDBlackjackCountDown)='+this.CountDownSetting+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 30036;
	}

	public getCmdName() : string
	{
		return 'ScBlackjackUpdateSetting';
	}

}
